import clsx from 'clsx';
import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

import Modal from '@mui/material/Modal';

interface TIModalProps {
  children: React.ReactNode;
  customHeader?: boolean;
  disableScrollLock?: boolean;
  id?: string;
  isFullScreen?: boolean;
  isOpen: boolean;
  onClose: () => void;
  parentClass?: string;
  withLogo?: boolean;
}

const TIModal = ({
  children,
  id,
  isFullScreen = false,
  isOpen,
  onClose,
  parentClass,
  withLogo = false,
  disableScrollLock,
  customHeader = false,
}: TIModalProps) => {
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} id={id}>
      <div
        className={clsx(
          'TIModal',
          'absolute left-1/2 top-1/2 z-[1000] max-h-full -translate-x-1/2 -translate-y-1/2 rounded-2',
          parentClass,
          {
            'h-screen max-w-full xs:h-auto': isFullScreen,
            'h-auto max-w-full px-16': !isFullScreen,
          }
        )}
      >
        <div
          className={clsx('modal-container bg-background-white', {
            'h-full justify-start xs:h-auto xs:justify-center': isFullScreen,
            'h-auto justify-center': !isFullScreen,
          })}
        >
          {!customHeader ? (
            <>
              <button className="close-button" onClick={onClose}></button>
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <img src={TheInformationLogo} width={225} />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
